import * as React from 'react';

import { cn } from 'src/shared/helpers/utils';

export interface InputLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    children?: React.ReactNode;
}

const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(({ className, ...props }, ref) => {
    return (
        <label
            ref={ref}
            className={cn(
                'inline-flex items-center text-sm leading-5 peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-grey-80',
                className
            )}
            {...props}
        />
    );
});
InputLabel.displayName = 'InputLabel';

export { InputLabel };
